module.exports = __webpack_public_path__ + "img/left-left.dd246ea4.png";